// Text pasted from email or docs arrives with non-breaking spaces between words. Browsers never wrap on
// those, so a whole paragraph renders as one line that runs off the chat bubble. Plain spaces read the same.
const NON_BREAKING_SPACES = /[\u00A0\u2007\u202F]/g;

const normalizeChatText = text => (typeof text === 'string' ? text.replace(NON_BREAKING_SPACES, ' ') : text);

module.exports = { normalizeChatText };
